import { render } from "./UpdateCommissions.vue?vue&type=template&id=7f9b870e"
import script from "./UpdateCommissions.vue?vue&type=script&lang=js"
export * from "./UpdateCommissions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__